(function() {
    let testimonials = document.querySelector('section.testimonials');
    if (! testimonials) return;

    async function startApp() {
        testimonials.classList.remove('d-none');

        let swiperDiv = testimonials.querySelector('#testimonialsSwiper');
        let swiper = new Swiper(swiperDiv, {
            // Optional parameters
            direction: 'horizontal',
            loop: true,

            // If we need pagination
            // pagination: {
            //     el: '.swiper-pagination',
            // },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            // And if we need scrollbar
            // scrollbar: {
            //     el: '.swiper-scrollbar',
            // },

            on: {
                init: function() {},
            },
        });
    }

    async function injectSwiper() {
        await Promise.all([
            window.injectJs('/assets/tp/swiper@11.2.6/swiper-bundle.min.js'),
            window.injectCss('/assets/tp/swiper@11.2.6/swiper-bundle.min.css')
        ]);
    }

    async function initializeSlider() {
        await injectSwiper();
        startApp();
    }

    initializeSlider();
})();